<template>
	<div class="view-school">
		<Modal
			:show="show_process_fee_structure"
			content_class="col-12 col-md-11 col-lg-9 col-xl-8 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Process Fee Structure
							</div>
							<div class="content-desc">
								Select terms to proceed
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="
								$store.commit(
									'show_process_fee_structure',
									false,
								)
							"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-lg-11 col-xl-10">
								<div
									class="content-box"
									v-if="
										selected_student_fee_structures.length >
											0 &&
										selected_school &&
										selected_student
									"
								>
									<div class="card fee-card mb-4">
										<div class="school-details">
											<div class="class">
												{{
													selected_school.school_name
												}}
											</div>
											<div class="txt-grey">
												{{
													selected_school.school_description
												}}
											</div>
										</div>
										<div class="student-details">
											<div class="class">
												{{
													selected_student
														.student_details
														.student_name
												}}
											</div>
											<div class="class">
												{{
													selected_student
														.class_details
														.grade_name
												}}
											</div>
										</div>
									</div>

									<div class="card fee-card">
										<!-- <div class="clearfix">
                                 <div class="f-r status tx-green" :class="{'tx-yellow': selected_student_fee_structures.status !== 'ACTIVE'}">{{selected_student_fee_structures.status}}</div>
                              </div> -->

										<!-- <div class="time"></div> -->
										<!-- <div class="total">{{selected_student_fee_structures.currency}} {{utils.numberWithCommas(selected_student_fee_structures.total)}}</div> -->

										<div
											class="term"
											v-for="term in selected_student_fee_structures"
											:key="term.term_system_ref"
										>
											<div class="row">
												<div class="col-1 custom-check">
													<Checkbox
														:name="
															term.term.term_name
														"
														v-model="
															term.is_selected
														"
													/>
												</div>
												<div class="col-11">
													<div
														class="overlay"
														v-show="
															!term.is_selected
														"
													></div>
													<div class="name">
														{{
															term.term.term_name
														}}
														({{
															moment(
																term.term
																	.start_date,
																'YYYY-MM-DD',
															).format(
																'Do MMM YYYY',
															)
														}}
														-
														{{
															moment(
																term.term
																	.end_date,
																'YYYY-MM-DD',
															).format(
																'Do MMM YYYY',
															)
														}})
													</div>
													<div
														class="time"
														v-if="
															term.term
																.academic_year_details
														"
													>
														Academic Year:
														{{
															term.term
																.academic_year_details
																.academic_name
														}}
													</div>
													<div class="small-title">
														MANDATORY
													</div>

													<div
														class="price-item"
														v-for="item in term
															.term_fees
															.mandatory"
														:key="
															item.fee_system_ref
														"
													>
														<div class="row">
															<div
																class="col-8 item-title"
															>
																{{
																	item.fee_item_name
																}}
															</div>

															<div
																class="col-4 amount"
															>
																{{
																	utils.numberWithCommas2(
																		item.amount,
																	)
																}}
															</div>
														</div>
													</div>

													<div class="small-title">
														OPTIONAL
													</div>
													<div
														class="price-item"
														v-for="item in term
															.term_fees.optional"
														:key="
															item.fee_system_ref
														"
														:class="{
															muted: !item.is_selected,
														}"
													>
														<div class="row">
															<div
																class="col-1 item-title custom-check"
															>
																<Checkbox
																	:name="
																		item.fee_item_name
																	"
																	v-model="
																		item.is_selected
																	"
																/>
															</div>
															<div
																class="col-7 item-title"
															>
																{{
																	item.fee_item_name
																}}
															</div>
															<!-- <div class="col-4 amount">
                                                <InputText
                                                   type="number"
                                                   :model="item.amount"
                                                   v-model="item.amount"
                                                   :placeholder="`${item.min_amount} - ${item.max_amount}`"
                                                   @input="validateInput(item,term)"
                                                />
                                             </div> -->
															<div
																class="col-4 amount"
															>
																{{
																	utils.numberWithCommas2(
																		item.amount,
																	)
																}}
															</div>
														</div>
														<div
															class="small-error tx-danger"
															v-if="item.msg"
														>
															{{ item.msg }}
														</div>
													</div>
												</div>
											</div>

											<div class="total-box">
												<div class="row">
													<div
														class="col-8 item-title"
													>
														Total
													</div>
													<div class="col-4 amount">
														{{
															calculateTotal(term)
																.total_str
														}}
													</div>
												</div>
											</div>
										</div>

										<div class="sum-total clearfis">
											<div class="total f-r">
												{{
													selected_student_fee_structures.currency
												}}
												{{
													utils.numberWithCommas2(
														all_total,
													)
												}}
											</div>
										</div>

										<div class="btn-box">
											<button
												class="f-r btn btn-green btn-long"
												@click="
													generateInvoice({
														router: $router,
														fee_structure:
															selected_student_fee_structures,
														all_total:
															utils.numberWithCommas(
																all_total,
															),
													})
												"
											>
												Generate Invoice
											</button>
										</div>
									</div>
								</div>
								<div class="white-content mt-4" v-else>
									<div class="title">
										No Fee Structures Found!
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Checkbox: () => import('@/libs/clarks/components/checkbox'),
		Modal: () => import('../templates/others/modal'),
		InputText: () => import('@/libs/clarks/components/text'),
	},
	computed: {
		...mapGetters([
			'activeTab',
			'school_details',
			'loading',
			'selected_student',
			'selected_school',
			'show_process_fee_structure',
			'selected_fee_structure',
			'selected_student_fee_structures',
		]),
	},
	data() {
		return {
			utils,
			moment,
			all_total: 0,
		};
	},
	methods: {
		...mapActions(['generateInvoice']),
		calculateTotal(term) {
			let total = 0;

			if (term.is_selected) {
				for (let i = 0; i < term.term_fees.mandatory.length; i++) {
					if (term.term_fees.mandatory[i].amount) {
						total += Number(term.term_fees.mandatory[i].amount);
					}
				}

				for (let i = 0; i < term.term_fees.optional.length; i++) {
					if (
						term.term_fees.optional[i].amount &&
						term.term_fees.optional[i].is_selected
					) {
						total += Number(term.term_fees.optional[i].amount);
					}
				}

				term.subtotal = total;
				this.calculateAllTotal();
			}
			return {
				total_str: `KES ${utils.numberWithCommas(Math.round(total * 100) / 100)}`,
				total,
			};
		},
		calculateAllTotal() {
			let total = 0;

			if (
				this.selected_student_fee_structures &&
				this.selected_student_fee_structures
			) {
				for (
					let i = 0;
					i < this.selected_student_fee_structures.length;
					i++
				) {
					const term = this.selected_student_fee_structures[i];
					if (term.is_selected && term.subtotal) {
						total += term.subtotal;
					}
				}
			}

			this.all_total = total;
		},
		validateInput(item, term) {
			if (item.amount > item.max_amount) {
				item.amount = item.max_amount;
				item.msg = `Amount provided is greater than the max amount: ${item.max_amount}`;
			} else if (item.amount < item.min_amount) {
				item.amount = item.min_amount;
				item.msg = `Amount provided is less than the min amount: ${item.min_amount}`;
			} else {
				item.msg = null;
				this.calculateTotal(term);
			}
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-school {
	.notification {
		padding: 22px 0;
		border-bottom: solid 1px #f5f9fb;
		cursor: pointer;

		.content-box {
			width: calc(100% - 65px);

			.title {
				color: #3d4661;
				font-weight: 600;
				font-size: 16px;
			}
			.txt {
				color: #646f79;
				font-size: 14px;
			}
			.date {
				color: #646f79;
				font-size: 13px;
				font-weight: 600;
			}
		}
	}

	.student-details {
		margin: 10px 0 0 0;
	}
	.fee-card {
		.txt-grey {
			font-size: 12px;
			color: #646f79;
		}
		.sum-total {
			.total {
				text-align: right;
				color: var(--ne-blue);
				font-size: 18px;
				font-weight: 600;
				padding: 10px 0 10px 30px;
				border-bottom: solid var(--text-color) 3px;
				border-top: solid var(--text-color) 3px;
			}
		}
		.term {
			margin: 0 0 40px 0;

			.overlay {
				position: absolute;
				top: 0;
				right: 0;
				left: 0;
				cursor: disabled;
				background: rgba(255, 255, 255, 0.6);
				bottom: 0;
			}
			.small-error {
				font-size: 11px;
				font-weight: 600;
				color: var(--danger);
				text-align: right;
			}
			.name {
				font-size: 13px;
				font-weight: 600;
				text-transform: uppercase;
			}

			.small-title {
				font-size: 11px;
				font-weight: 600;
				margin: 10px 0 3px 5px;
			}
		}

		.price-item {
			font-size: 14px;
			margin: 10px 0;

			.item-title {
				font-size: 13px;
			}
			.amount {
				text-align: right !important;
				font-weight: 600;

				input {
					// text-align: right !important;
					padding: 2px 0 !important;
					border-top: 0;
					border-left: 0;
					border-right: 0;
					border-radius: 0;
				}
			}

			&.muted {
				color: hsl(0, 0%, 74%);

				input {
					color: hsl(0, 0%, 74%);
				}
			}
		}
		.total-box {
			border-top: solid 1px var(--border-grey);
			border-bottom: solid 1px var(--border-grey);
			padding: 7px 0;
			margin: 10px 0 0 0;
			font-weight: 600;

			.amount {
				color: var(--ne-blue);
				text-align: right;
			}
		}

		.status {
			font-size: 12px;
			text-transform: uppercase;
			font-weight: 600;

			&.tx-yellow {
				color: var(--ne-yellow);
			}
		}
		.ref {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.class {
			font-size: 13px;
			text-transform: uppercase;
			font-weight: 600;
		}
		.time {
			font-size: 13px;
			color: var(--ne-green);
		}

		.s-class {
			color: #9c7bfc;
			font-size: 13px;
		}
		.total {
			color: var(--ne-blue);
			font-size: 15px;
			font-weight: 600;
			padding: 0 0 10px 0;
			margin: 0 0 20px 0;
			border-bottom: solid 1px var(--border-grey);
		}
	}
}
</style>
